export const getTextColor = theme =>
  theme?.name === "contrast"
    ? "var(--mode-text-neutral-default-weak)"
    : "var(--mode-text-neutral-weakest)";
